import React, { useEffect } from "react";
import Navbar from "../Navbar";
import "./ViewIndustrialCertificate.css";
import { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import DownloadPage from "../DownloadPage";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import {
  Box,
  Button,
  Grid,
  Hidden,
  TextField,
  Typography,
} from "@mui/material";

function ViewCertificate() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [productInput, setproduct] = useState([]);
  const [certificateDetails, setcertificateDetails] = useState([]);
  const [verticalInput, setverticalInput] = useState([]);
  const [pagetwo, setpagetwo] = useState([]);
  const [itemDetails, setitemDetails] = useState([]);
  // console.log('data',verticalInput)
  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  const { id } = useParams();
  useEffect(() => {
    const product_id = id;
    axios.get(`/api/view_industrial_certificate/${product_id}`).then((res) => {
      if (res.data.status === 200) {
        console.log('itemDetails',res.data);
        setproduct(res.data.chalans);
        setitemDetails(res.data.itemDetails);
        setverticalInput(res.data.chalanseqence);
        setcertificateDetails(res.data.certificateDetails);
        setpagetwo(res.data.pagetwodetails)
      } else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/challan");
      }
      setLoading(false);
    });
  }, [id, navigate]);

  const handleInput = (e) => {
    e.persist();
    setproduct({ ...productInput, [e.target.name]: e.target.value });
  };
  if (loading) {
    swal({
      title: "Loading",
      text: "Please Wait!!!",
      timer: 1000,
      buttons: false,
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === "timer") {
          //console.log('I was closed by the timer')
        }
      }
    );
  }

  const challanId = id;
  const handlePrint = () => {
    window.print();
  };
  return (
    <div>
      <main>
        <Navbar />
        <div className="downloadcertbutton">
          <button className="certbutton">
            <a
              style={{ color: "white", textDecoration: "none" }}
              href={"https://cert.geekay.biz/backend/api/indcertificatepage1/" + challanId}
              // href={"/api/indcertificatepage1/" + challanId}
              target="_blank"
              rel="noreferrer"
            >
              Certificate Page 1 Download
            </a>
          </button>
          <button className="certbutton">
            <a
              style={{ color: "white", textDecoration: "none" }}
              href={"https://cert.geekay.biz/backend/api/indcertificatepage2/" + challanId}
              // href={"/api/indcertificatepage2/" + challanId}
              target="_blank"
              rel="noreferrer"
            >
              Certificate Page 2 Download
            </a>
          </button>
          <ThemeProvider theme={theme}>
              <Button
                component={Link}
                style={{ color: "white", textDecoration: "none",display: "inline-block",padding: '12px 15px',fontSize: '15px',borderRadius: '15px',fontSize: '15px'}}
                to={`/certificates/update_industrial_certificate/${challanId}`}
                variant="contained"
                color="apple"
              >
                Edit Certificate
              </Button>
              {/*<Button component={Link} to="/edit_challan/${id}" variant='contained' color='apple'>Update Challan</Button>*/}
          </ThemeProvider>
        </div>

        {/* <div className="m-1 border border-dark p-5"> */}
        <div className="indmaindiv">
          <section>
            <div className="topheading">
                <p>DIRECTORATE OF INDUSTRIAL SAFETY AND HEALTH, 1963</p>
            </div>
            <div className="parent">
                <div className="child1">
                    <p>Form 11</p>
                </div>
                <div className="child2">
                    <p>See Rule 62 & 64</p>
                </div>
                <div className="child3">
                    <p>Test Certificate No:</p>
                </div>
                <p>{certificateDetails.memo_no}</p>
            </div>
          </section>
                <div className="thirdline">
                    <p>Prescribed INITIAL & PERIODICAL TEST Report of examination of hoist, lift, lifting machines, chains, ropes and lifting tackles</p>
                </div>
          <section>
                <div className="parent">
                <div className="child18">
                    <p>1) &nbsp;&nbsp;&nbsp;Name & Address of the Occupier</p>
                </div>
                <div className="child19">
                    <p>{productInput.party_name}</p>
                    <p className="partyaddress">{productInput.address}</p>
                </div>
                </div>
                <div className="linetwo">
                    <p>2) &nbsp;&nbsp;&nbsp;Name & Address of the factory</p>
                </div>
                <div className="linethree">
                    <p>3) &nbsp;&nbsp;&nbsp;Details of the Test & Examination Carried out:</p>
                </div>
          </section>

          <section>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th className="tabheading" scope="col" style={{ width: "15%" }}>
                    Type Identifiation/ Distinguishing Number of Mark
                  </th>
                  <th className="tabheading" scope="col" style={{ width: "38%" }}>
                    Description, Dimension & Material of hoist, lift, lifting, chains, ropes and lifting tackles
                  </th>
                  <th className="tabheading" scope="col" style={{ width: "8%" }}>
                    Numbers tested
                  </th>
                  <th className="tabheading" scope="col" style={{ width: "8%" }}>
                    Date of test
                  </th>
                  <th className="tabheading" scope="col" style={{ width: "8%" }}>
                    Test load applied (Tonnes)
                  </th>
                  <th className="tabheading" scope="col" style={{ width: "8%" }}>
                    Safe working load (Tonnes)
                  </th>
                  <th className="tabheading" scope="col" style={{ width: "15%" }}>
                    Date of Construction re-construction & date when first taken to use
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td height="5px" className="secondrow">[3 (a)(1)]</td>
                  <td className="secondrow">[3 (a)(2)]</td>
                  <td className="secondrow">[3 (a)(3)]</td>
                  <td className="secondrow">[3 (a)(4)]</td>
                  <td className="secondrow">
                  [3 (a)(5)]
                  </td>
                  <td className="secondrow">[3 (a)(6)]</td>
                  <td className="secondrow">[3 (b)]</td>
                </tr>
                <tr></tr>
                <tr>
                  {/* <td height="300px"></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td> */}
                  <td height="650px">
                    {itemDetails.map((post) => {
                      const lines = post.descriptive.split("\n");
                      const numLines = lines.length;
                      if (numLines > 4 && numLines < 8) {
                        return (
                          <div style={{ minHeight: "200px" }} key={post.pcode}>
                            {post.distin}
                            <br />
                          </div>
                        );
                      } else if (numLines > 8 && numLines < 13) {
                        return (
                          <div style={{ minHeight: "230px" }} key={post.pcode}>
                            {post.distin}
                            <br />
                          </div>
                        );
                      } else {
                        return (
                          <div style={{ minHeight: "130px" }} key={post.pcode}>
                            {post.distin}
                            <br />
                          </div>
                        );
                      }
                    })}
                  </td>
                  {/* <td height="450px">{itemDetails.map((post)=>{
                    const lines = post.descriptive.split('\n');
                    const numLines = lines.length;
                    if (numLines>4 && numLines<8) {
                      return(
                        <div style={{minHeight:"200px"}}  key={post.pcode}>{post.sn}<br /></div>);
                    } 
                    else if (numLines > 8 && numLines < 13) {
                       return(
                        <div style={{ minHeight:"230px" }}  key={post.pcode}>{post.sn}<br /></div>);
                    } else {
                      return(
                        <div style={{ minHeight:"130px" }}  key={post.pcode}>{post.sn}<br /></div>);
                    }
                  })}</td> */}
                  <td height="450px">
                    {itemDetails.map((post) => {
                      const lines = post.descriptive.split("\n");
                      const numLines = lines.length;
                      const desc = post.descriptive;
                      if (numLines > 4 && numLines < 8) {
                        return (
                          //<div style={{minHeight:"200px"}}  key={post.pcode}>{post.descriptive}<br /></div>);
                          <div style={{ minHeight: "200px" }} key={post.pcode}>
                            {lines.map((post) => {
                              return (
                                <div>
                                  {post}
                                  <br />
                                </div>
                              );
                            })}
                            <br />
                          </div>
                        );
                      } else if (numLines > 8 && numLines < 13) {
                        return (
                          <div style={{ minHeight: "230px" }} key={post.pcode}>
                            {lines.map((post) => {
                              return (
                                <div>
                                  {post}
                                  <br />
                                </div>
                              );
                            })}
                            <br />
                          </div>
                        );
                      } else {
                        return (
                          <div style={{ minHeight: "130px" }} key={post.pcode}>
                            {lines.map((post) => {
                              return (
                                <div>
                                  {post}
                                  <br />
                                </div>
                              );
                            })}
                            <br />
                          </div>
                        );
                      }
                    })}
                  </td>
                  <td height="450px">
                    {itemDetails.map((post) => {
                      const lines = post.descriptive.split("\n");
                      const numLines = lines.length;
                      if (numLines > 4 && numLines < 8) {
                        return (
                          <div style={{ minHeight: "200px" }} key={post.pcode}>
                            {post.test}
                            <br />
                          </div>
                        );
                      } else if (numLines > 8 && numLines < 13) {
                        return (
                          <div style={{ minHeight: "230px" }} key={post.pcode}>
                            {post.test}
                            <br />
                          </div>
                        );
                      } else {
                        return (
                          <div style={{ minHeight: "130px" }} key={post.pcode}>
                            {post.test}
                            <br />
                          </div>
                        );
                      }
                    })}
                  </td>
                  <td>{productInput.date}</td>
                  <td height="450px">
                    {itemDetails.map((post) => {
                      const lines = post.descriptive.split("\n");
                      const numLines = lines.length;

                      if (numLines > 4 && numLines < 8) {
                        return (
                          <div style={{ minHeight: "200px" }} key={post.pcode}>
                            {post.pltonns}
                            <br />
                          </div>
                        );
                      } else if (numLines > 8 && numLines < 13) {
                        return (
                          <div style={{ minHeight: "230px" }} key={post.pcode}>
                            {post.pltonns}
                            <br />
                          </div>
                        );
                      } else {
                        return (
                          <div style={{ minHeight: "130px" }} key={post.pcode}>
                            {post.pltonns}
                            <br />
                          </div>
                        );
                      }
                    })}
                  </td>
                  <td height="450px">
                    {itemDetails.map((post) => {
                      const lines = post.descriptive.split("\n");
                      const numLines = lines.length;

                      if (numLines > 4 && numLines < 8) {
                        return (
                          <div style={{ minHeight: "200px" }} key={post.pcode}>
                            {post.swltonns}<br/>{post.swltonns2}
                            <br />
                          </div>
                        );
                      } else if (numLines > 8 && numLines < 13) {
                        return (
                          <div style={{ minHeight: "230px" }} key={post.pcode}>
                            {post.swltonns}<br/>{post.swltonns2}
                            <br />
                          </div>
                        );
                      } else {
                        return (
                          <div style={{ minHeight: "130px" }} key={post.pcode}>
                            {post.swltonns}<br/>{post.swltonns2}
                            <br />
                          </div>
                        );
                      }
                    })}
                  </td>
                  <td height="450px">
                    {itemDetails.map((post) => {
                      const lines = post.descriptive.split("\n");
                      const numLines = lines.length;

                      if (numLines > 4 && numLines < 8) {
                        return (
                          <div style={{ minHeight: "200px" }} key={post.pcode}>
                            {post.constructDate}
                            <br />
                          </div>
                        );
                      } else if (numLines > 8 && numLines < 13) {
                        return (
                          <div style={{ minHeight: "230px" }} key={post.pcode}>
                            {post.constructDate}
                            <br />
                          </div>
                        );
                      } else {
                        return (
                          <div style={{ minHeight: "130px" }} key={post.pcode}>
                            {post.constructDate}
                            <br />
                          </div>
                        );
                      }
                    })}
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
              <div className="parent">
              <div className="child4">
                  <p >SEE REVERSE</p>
              </div>
              <div className="child5">
                  <p>Contd Pg. 2</p>
              </div>
              </div>
          <section>
              <div className="sealdiv">
                SEAL
              </div>
          </section>
        </div>
        <div className="indmaindiv">
          <section>
            <div className="page2heading">
            <p>PAGE 2</p>
            </div>
          </section>

          <section>
                <div className="parent">
                  <div className="child6">
                     <p>
                     4) Date of last examinations made under section 29(1)(a)(iii) and by whom it was carried out.
                     </p>
                  </div>
                  <div className="child7">
                    <p>{pagetwo.fourth}</p>
                  </div>
                </div>
          </section>
          <section>
                <div className="parent">
                  <div className="child6">
                     <p>
                      5) (A) Maintenance (List of parts,if any, which were inacessible)
                          Are the following parts of the hoist ort lift properly maintained and in good working order? If not, state what defects have been found.<br/>
                          (a) Enclosure of hoistway or liftway.<br/>
                          (b) Landing gates and cage gate(s).<br/>
                          (c) Interlocks on the landing gates and age gate(s).<br/>
                          (d) Other gate fastenings.<br/>
                          (e) Cage and platform amd fittings, cage guides, buffers, interior of the hoistway or liftway.<br/>
                          (f) Overrunning devices<br/>
                          (g) Suspension ropes or chains and their attachments<br/>
                          (h) Safety gear, i.e. arrangements for preventing fall of platform or cage brakes.<br/>
                          (i) Brakes<br/>
                          (j) Work of spur gearing<br/>
                          (k) Other electrical equipment.<br/>
                          (l) Other parts<br/>
                      </p>
                  </div>
                  <div className="child7">
                    <p>{pagetwo.fifth_a}</p>
                  </div>
                </div>
          </section>
          <section>
                <div className="parent">
                  <div className="child6">
                     <p>
                     5(B) Date and number of the certificate relating to any test and examination made under sub- rule(1) of rule 64 together with the name of the person who issued the certificate.
                     </p>
                  </div>
                  <div className="child7">
                    <p>{pagetwo.fifth_b}</p>
                  </div>
                </div>
          </section>
          <section>
                <div className="parent">
                  <div className="child6">
                     <p>
                     5(C) (i)Date of annealing or their heat treatment of the chain and lifting tackle carried out under sub-rule(5) of rule 64 and by whom it was carried out.
                     </p>
                  </div>
                  <div className="child7">
                    <p>{pagetwo.fifth_c_one}</p>
                  </div>
                </div>
          </section>
          <section>
                <div className="parent">
                  <div className="child6"> 
                     <p>
                     5(C) (ii)Particulars of any defect found at any such examination or after annealing and affecting the safe working load and of the steps taken to remedy such defect.
                     </p>
                  </div>
                  <div className="child7">
                    <p>{pagetwo.fifth_c_two}</p>
                  </div>
                </div>
          </section>
          <section>
                <div className="parent">
                  <div className="child6">
                     <p>
                     6) Repairs, renewals or alterations (if any) required and the period within which they should be executed and maximum safe working load subject to repairs, renewals or alterations(if any)
                     </p>
                  </div>
                  <div className="child7">
                    <p>{pagetwo.sixth}</p>
                  </div>
                </div>
          </section>
          <section>
            <p>
            I certify that on, _______________________________ I thoroughly examined the hoist,lift,lifting machines,chains,ropes and lifting tackles and details of examinations / tests carried out is enclosed herewith that the above is a correct report of the result.
            </p>
          </section>
          <section>
            <div className="parent">
              <div className="child8">
                <p>Signature &nbsp; __________________________________________________</p>
              </div>
              <div className="child9">
                <p>Counter Signature &nbsp; _______________________________________________</p>
              </div>
            </div>
          </section>
          <section>
            <div className="parent">
              <div className="child10">
                  Name of Competent Person
              </div>
              <div className="child11">
                  ___________________________________
              </div>
            </div>
          </section>
          <section>
            <div className="parent">
            <div className="child12">
                <p>Qualification</p>
            </div>
            <div className="child13">
              <p>___________________________________</p>
            </div>
            </div>
          </section>
          <section>
          <div className="parent">
            <div className="child14">
                <p>Address</p>
            </div>
            <div className="child15">
                <p>GEEKAY INDUSTRIES (INDIA)</p>
            </div>
          </div>
          </section>
          <section>
            <div className="parent">
              <div className="child16">
                <p>17 A, Sitafalwadi, Mazgaon, Mumbai 400010 </p>
                <p style={{ marginTop: -20 }}>www.geekaygroup.com Tel:23709839</p>
              </div>
              <div className="child17">
                  <p>SEAL</p>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}

export default ViewCertificate;
